
import React from 'react'

import ContentBlock from '../../components/ContentBlock'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import { ListGroup } from 'react-bootstrap'
import ResponsibleItem from '../../components/ResponsibleItem'

import TeamMemberSelector from '../../components/TeamMemberSelector/TeamMemberSelector'
import useTranslation from '@/Hooks/UseTranslation'

const Responsibles = () => {

  const { t } = useTranslation()

  const { itemOpened } = useProgrammation()

  if (itemOpened.type === 'hito' || itemOpened.type === 'reunion') {

    return null
  }

  return (
    <ContentBlock
      title={t('PROGRAMMATION_MANAGER:SectionResponsiblesTitle') + ` (${itemOpened.responsibles.length})`}
      collapsable
      isCollapsed={!itemOpened.responsibles.length}
    >
      <div style={{ textAlign: 'right' }}>
        <TeamMemberSelector onSelect={(user: any) => console.log(user)} />
      </div>
      <ListGroup>
        {itemOpened.responsibles.map((r: any, i: number) => (
          <ResponsibleItem
            key={i}
            user={r}
            onDeleted={() => console.log(r)}
            canDelete={!itemOpened.hasSubTasks}
          />
        ))}
      </ListGroup>
    </ContentBlock>
  )
}

export default Responsibles
